import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Alert } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import api from "API/Api"
import { Link } from "react-router-dom"

const AddVehicleCashAdvance = () => {
  const formRef = useRef()
  const [transporters, setTransporters] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [categories, setCategories] = useState([])
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const [tRes, cRes] = await Promise.all([api.get("transporters"), api.get("vehicle-deduction-categories")])
        const t = tRes.data.data?.data || tRes.data.data || []; setTransporters(Array.isArray(t) ? t : [])
        setCategories(Array.isArray(cRes.data.data) ? cRes.data.data : [])
      } catch (e) { console.error(e) }
    }; load()
  }, [])

  const handleTransporter = async v => {
    setVehicles([])
    if (v) { try { const r = await api.get("vehicles-by-transporter/" + v); setVehicles(r.data.data || []) } catch (e) {} }
  }

  const handleSubmit = async (e, values) => {
    try {
      const r = await api.post("create-vehicle-cash-advance", values)
      if (r.data.success) { formRef.current.reset(); setVehicles([]); setSubmitted(true); setTimeout(() => setSubmitted(false), 3000) }
    } catch (e) { console.error(e) }
  }

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader"><Row><Col md={6}><h4>Add Vehicle Cash Advance</h4></Col><Col md={6} style={{ textAlign: "right" }}><Link to="/vehicle-cash-advances" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col></Row></div>
      {submitted && <Alert color="success" className="mt-2">Vehicle Cash Advance Added Successfully!</Alert>}
      <AvForm className="mt-3" onValidSubmit={handleSubmit} ref={formRef}>
        <Row>
          <Col md={6}>
            <AvField type="select" name="transporter" label="Transporter *" required onChange={e => handleTransporter(e.target.value)}>
              <option value="">Select</option>
              {transporters.map((t, i) => <option key={i} value={t.id}>{t.transporterName}</option>)}
            </AvField>
          </Col>
          <Col md={6}>
            <AvField type="select" name="vehicle" label="Vehicle *" required>
              <option value="">Select</option>
              {vehicles.map((v, i) => <option key={i} value={v.id}>{v.vehicleNumber}</option>)}
            </AvField>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AvField type="select" name="category" label="Category">
              <option value="">Select</option>
              {categories.map((c, i) => <option key={i} value={c.id}>{c.categoryName}</option>)}
            </AvField>
          </Col>
          <Col md={6}>
            <AvField type="date" name="advanceDate" label="Advance Date *" required />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AvField type="number" name="advanceAmount" label="Advance Amount *" required validate={{ required: { value: true }, min: { value: 1 } }} />
          </Col>
          <Col md={6}>
            <AvField type="number" name="deductionPerBill" label="Deduction Amount Per Bill *" required validate={{ required: { value: true }, min: { value: 0 } }} />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AvField type="textarea" name="remarks" label="Remarks" />
          </Col>
        </Row>
        <button className="btn btn-primary mt-3" type="submit">Save Changes</button>
      </AvForm>
    </div>
  )
}
export default AddVehicleCashAdvance
